import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { fetchByket, createByket} from '../api';

const ByketForm = ({ setBykets }) => {
  const [name, setName] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createByket({name});

      const byket = await fetchByket();
      setBykets(byket);

      setName('');
    } catch (error) {
      console.error('Не вдалося додати букет:', error);
    }
  };

  return (
    <div>
      <Form onSubmit={handleSubmit} className="mt-3">
        <Form.Group className="mb-3">
          <Form.Label>Назва букету</Form.Label>
          <Form.Control
            type="text"
            placeholder="Введіть назву"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </Form.Group>

        <Button type="submit">Додати Букет</Button>
      </Form>
    </div>
  );
};

export default ByketForm;
